var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hc-base-upload',{ref:"hcBaseUploadRef",attrs:{"hcCaseFlightFileType":_vm.hcCaseFlightFileType,"hcCaseMasterId":_vm.hcCaseMasterId,"validateUploadFileOptions":_vm.validateUploadFileOptions,"objectType":_vm.objectType},on:{"downloadFile":_vm.downloadFile}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446c386c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/khachsan/hc-ks-upload.vue
// module id = null
// module chunks = 